
// 通用顶部条组件
const topbar = () => import("../../layout/topbar");
// 通用主体顶部组件
const AppHeader_Nav = () => import("../../layout/AppHeader_Navs");
// 通用主体头部组件
const AppHeader_main = () => import("../../layout/AppHeader_main");
// 通用底部组件
const AppFooter = () => import("../../layout/AppFooter_moonSample");
// 当前路由组件
const home = () => import('../../views/home.vue');
const AdvisoryCenter = () => import('../../views/AdvisoryCenter/index');
export default [{
  path: "/",
  name: "home",
  components: {
    // topbar: topbar,
    header: AppHeader_main,//AppHeader_Nav 顶部主体样式 || AppHeader_main 头部主体样式
    default: home,
    footer: AppFooter,
  },
  meta: {
    requireAuth: false // 需要验证登录状态
  },
  props: {
    header: {
      type: '2',//根据不同类型切入组件判断逻辑
    }
  },
},
{
  path: "/AdvisoryCenter",
  name: "AdvisoryCenter",
  components: {
    topbar: topbar,
    header: AppHeader_main,//AppHeader_Nav 顶部主体样式 || AppHeader_main 头部主体样式
    default: AdvisoryCenter,
    footer: AppFooter,
  },
  meta: {
    requireAuth: false, // 需要验证登录状态
  },
  props: {
    header: {
      type: '1',//根据不同类型切入组件判断逻辑
    }
  },
}, {
  path: "/HomeInfo",
  name: "HomeInfo",
  components: {
    // topbar: topbar,
    header: AppHeader_main,
    default: () => import('../../views/homeInfo/index.vue'),
    footer: AppFooter,
  },
  meta: {
    requireAuth: false
  },
  props: {
    header: {
      type: '1'
    }
  }
}, {
  path: "/HomeList",
  name: "HomeList",
  components: {
    // topbar: topbar,
    header: AppHeader_main,
    default: () => import('../../views/homeInfo/homeList.vue'),
    footer: AppFooter,
  },
  meta: {
    requireAuth: false
  },
  props: {
    header: {
      type: '1'
    }
  }
},
]
